import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly _isOpen = signal(
    typeof window === 'undefined' || window.innerWidth > 860
  );
  readonly isOpen = this._isOpen.asReadonly();

  toggle(): void {
    this._isOpen.update((v) => !v);
  }

  close(): void {
    this._isOpen.set(false);
  }

  open(): void {
    this._isOpen.set(true);
  }
}
